import { useState, useEffect } from 'react';

interface Version {
  version: string;
  date: string;
  title: string;
  changes: string[];
}

interface Changelog {
  versions: Version[];
}

export function useChangelog() {
  const [versions, setVersions] = useState<Version[]>([]);
  const [currentVersion, setCurrentVersion] = useState<string>('');

  useEffect(() => {
    const loadChangelog = async () => {
      try {
        const response = await fetch('/changelog.json');
        const data: Changelog = await response.json();
        
        // Sort versions by date in descending order
        const sortedVersions = [...data.versions].sort((a, b) => 
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        
        setVersions(sortedVersions);
        
        // Set current version as the latest one
        if (sortedVersions.length > 0) {
          setCurrentVersion(sortedVersions[0].version);
        }
      } catch (error) {
        console.error('Error loading changelog:', error);
      }
    };

    loadChangelog();
  }, []);

  return { versions, currentVersion };
}
